import {useRef} from 'react';
import {Modal} from '@cvent/carina/components/Modal';
import {Button} from '@cvent/carina/components/Button';
import {Illustration} from '@cvent/carina/components/Illustration';
import {DismissButton} from '@cvent/carina/components/ScrollViewWithBars';

type PaymentFailedProps = {
  handleClose: () => void;
};

const PaymentFailed = ({handleClose}: PaymentFailedProps) => {
  const headerRef = useRef<HTMLHeadingElement | null>(null);

  return (
    <Modal
      isOpen
      format="sm"
      onDismiss={handleClose}
      testID="payment-failed-modal"
      aria-labelledby="payment-failed-title"
    >
      <div className="flex flex-col box-border w-[420px] h-[384px] p-6 pt-4">
        <div className="mb-4 flex justify-end">
          <DismissButton aria-label="Dismiss" onClick={handleClose} />
        </div>
        <div className="flex justify-center " aria-hidden>
          <Illustration name="warning" width="120" height="120" aria-hidden />
        </div>
        <h1
          id="payment-failed-title"
          ref={headerRef}
          tabIndex={-1}
          className="text-[24px] font-bold leading-[var(--carina-line-height-tight)] text-[var(--carina-text-color-base)] mb-4"
        >
          Payment didn't go through
        </h1>
        <p className="text-[14px] leading-[var(--carina-line-height-normal)] text-[var(--carina-text-color-base)] mb-4">
          Verify your information and try again. Don't worry, you won't be
          charged twice. For assistance, contact support at{' '}
          <a
            aria-label="socialtables support email link"
            href="mailto:ST.support@cvent.com"
            className="text-[var(--carina-link-color,#006ae1)]"
          >
            ST.support@cvent.com
          </a>
          .
        </p>
        <div className="flex justify-end">
          <Button
            text="Try again"
            onClick={handleClose}
            type="button"
            appearance="lined"
            className="w-[164px]"
          />
        </div>
      </div>
    </Modal>
  );
};

export default PaymentFailed;
